export const IDEAS_UPLOADER_ID = 'ideas'
